<template>
  <nav :class="['navbar', 'navbar-default', {'active': isActive}]" id="navbar">
    <div class="container-fluid">
      <div class="navbar-collapse collapse in">
        <ul class="nav navbar-nav navbar-mobile">
          <li>
            <button type="button" class="sidebar-toggle" v-on:click="sidebarToggle">
              <i class="fa fa-bars"></i>
            </button>
          </li>
          <li class="logo">
            <a class="navbar-brand" href="#">
              <template v-if="logoUrl">
                <img class="img-responsive" :src="logoUrl" />
              </template>
              <template v-else>
                {{ pageTitle }}
              </template>
            </a>
          </li>
          <li v-if="currentUser">
            <button type="button" class="navbar-toggle" v-on:click="navbarToggle">
              <img class="profile-img" :src="currentUser.image">
            </button>
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-left">
          <li class="navbar-title" v-if="title">
            <a v-if="btnBack" class="btn-back" v-on:click="btnBack">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </a>
            <span class="highlight">{{ title }}</span>
          </li>
          <!--
          <li class="navbar-search hidden-sm">
            <input id="search" type="text" placeholder="Search..." autocomplete="off">
            <button class="btn-search"><i class="fa fa-search"></i></button>
          </li>
          -->
        </ul>
        <ul class="nav navbar-nav navbar-right">
          <template v-if="$root.navbarSections">
            <navsection v-for="section in $root.navbarSections"
                        :title="$t(section.title)"
                        :color-class="section.colorClass || ''"
                        :icon="section.icon"
                        :view="section.view"
                        :counter="section.kind === 'orders' ? orderCount : section.kind === 'projects' ? projectCount : undefined"
                        :list="section.kind === 'orders' ? orders : section.kind === 'projects' ? projects : []"></navsection>
          </template>
          <template v-else-if="!hideLists">
            <navsection :title="$t('Orders.title')" color-class="" icon="shopping-basket" view="Orders" :counter="orderCount" :list="orders"></navsection>
            <navsection :title="$t('Projects.title')" color-class="danger" icon="cog" view="Projects" :counter="projectCount" :list="projects"></navsection>
            </template>
          <!--
          <navsection title="Nachrichten" color-class="warning" icon="comments" view="Messages" :counter="messageCount" :list="messages"></navsection>
          -->

          <li v-if="currentUser" :class="['dropdown', 'profile', {'impersonate': currentUser.impersonate}]">
            <a v-on:click="openView('UserSettings')" class="dropdown-toggle" data-toggle="dropdown">
              <img class="profile-img" :src="currentUser.image">
              <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
              <div class="title">{{ $t('Common.settings') }}</div>
            </a>
            <div class="dropdown-menu">
              <a class="profile-info">
                <h4 class="username">{{ currentUser.fullname }}</h4>
              </a>
              <ul class="action">
                <li>
                  <a v-on:click="openLocaleSettings()">
                    <span class="pull-right">
                      <img class="img-responsive" :src="currentLangIcon" width="24" />
                    </span>
                    {{ $t('Common.languageSettings') }}
                  </a>
                </li>
                <li>
                  <a v-on:click="openView('UserSettings')">
                    {{ $t('Common.settings') }}
                  </a>
                </li>
                <li v-if="!disableAddress">
                  <a v-on:click="openView('Addresses')">
                    {{ $t('Addresses.title') }}
                  </a>
                </li>
                <li v-if="!disableInvoices">
                  <a v-on:click="openView('Invoices')">
                    {{ $t('Invoices.title') }}
                  </a>
                </li>
                <li>
                  <a v-on:click="logout" href="#">
                    {{ $t('Login.logout') }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarSection from './NavbarSection.vue';

export default {
  components: {
    'navsection': NavbarSection
  },
  props: {
    logoUrl: {
      type: String
    },
    pageTitle: {
      type: String
    },
    title: {
      type: String
    },
    currentView: {
      type: String
    },
    currentUser: {
      type: Object
    },
    isActive: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default () {
        return {};
      }
    },
    projects: {
      type: Array,
      default () {
        return [];
      }
    },
    messages: {
      type: Array,
      default () {
        return [];
      }
    },
    orders: {
      type: Array,
      default () {
        return [];
      }
    },
    projectCount: {
      type: Number
    },
    messageCount: {
      type: Number
    },
    orderCount: {
      type: Number
    },
    btnBack: {
      type: Function
    },
    imgPath: {
      type: String
    },
    hideLists: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLangIcon() {
      return `/img/flags/${this.$i18n.locale}.png`;
    },
    disableAddress() {
      return this.$root.hasOwnProperty('disableAddressEdit') && (typeof this.$root.disableAddressEdit != 'undefined') && this.$root.disableAddressEdit;
    },
    disableInvoices() {
      return this.$root.hasOwnProperty('disableInvoiceList') && (typeof this.$root.disableInvoiceList != 'undefined') && this.$root.disableInvoiceList;
    }
  },
  methods: {
    openView (view) {
      this.$parent.openView(view);
    },
    logout () {
      this.$parent.logout();
    },
    sidebarToggle() {
      this.$parent.sidebarOpen = !this.$parent.sidebarOpen;
    },
    navbarToggle() {
      this.$parent.navbarOpen = !this.$parent.navbarOpen;
    },
    openLocaleSettings() {
      this.$parent.openLocaleSettings();
    }
  }
}
</script>
